module.exports = "<div class=\"card-body screen-title-body\">\n    <div class=\"screen-title-content\">\n        <h5>Roles</h5>\n    </div>\n</div>\n<ng-template [ngxPermissionsOnly]=\"[permissions.ROLES_ADD]\">\n    <button class=\"btn btn-success\" (click)=\"addRole()\"><i class=\"fa fa-plus-square fa-lg\"></i> Create</button>\n</ng-template>\n<app-rights-roles-list></app-rights-roles-list>"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/edi/angular/app/views/rights/roles/roles.component.html
// module id = ../../../../../angular/app/views/rights/roles/roles.component.html
// module chunks = main